/**
 * Marker class added to the dropdown popup of multi-select instances. CSS in
 * `index.css` keys off this to hide already-selected options from the list
 * (Lemmala UX). The dropdown is portaled to body, so the class must travel
 * with it via `popupClassName` rather than living on the trigger.
 */
export const MULTI_DROPDOWN_CLASS = 'lemmala-select-dropdown-multiple'
